module.exports = __webpack_public_path__ + "static/media/top4.f3da00f8.jpg";